import { EventCategory } from "@/types/ui";
import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class RabbitFarmBuildingTileEntity extends TileEntity {
	public static readonly eventType = EventCategory.EASTER;

	public static readonly frameName = FrameName.RABBIT_FARM;
}

export default RabbitFarmBuildingTileEntity;
